import { Warning } from "@phosphor-icons/react";
import clsx from "clsx";

import { HTTPError } from "common/helpers/HTTP";

import type { HTMLAttributes } from "react";
import type { GlobalError } from "react-hook-form";

type ErrorMessageProps = HTMLAttributes<HTMLDivElement> & {
  error: Error | GlobalError;
  fallbackErrorMessage: string;
  size: "sm" | "md";
};

function ErrorMessage({
  size,
  className,
  error,
  fallbackErrorMessage,
  ...rest
}: ErrorMessageProps) {
  if (error) {
    let errorMessage: string;

    if (error instanceof HTTPError) {
      errorMessage = error.serverMessage;
    } else if (error.message) {
      errorMessage = error.message;
    }

    if (!errorMessage) {
      errorMessage = fallbackErrorMessage;
    }

    return (
      <div
        {...rest}
        className={clsx(
          "ml-1 flex items-start text-red-500",
          size === "sm" ? "gap-0.5" : "gap-1",
          className,
        )}
      >
        <Warning weight="fill" size={size === "sm" ? 16 : 20} />
        <p
          className={clsx(
            size === "sm" ? "text-xs" : "text-sm",
            "first-letter:capitalize",
          )}
        >
          {errorMessage}
        </p>
      </div>
    );
  }
}

ErrorMessage.displayName = "ErrorMessage";

export default ErrorMessage;
